<div class="centered-scrollable">
    <div class="vertical-spacer"></div>
    <div class="content">
        <ng-content></ng-content>
    </div>
    <div class="vertical-spacer"></div>
</div>